import axios from "axios";


export const patientQuestionareRequest = async (params: {
  patient_uid: string;
}): Promise<void> => {
  const { patient_uid } = params;
  const { data } = await axios.get(
    `/api/v2/questionaire_questions?patient_uid=${patient_uid}`
  );

  return data;
};